import React, { useEffect, useState } from 'react'
import { iconwrapper } from '../../../../../../config/commonfunctions';
import { ADD_ICON, BLOCKLARGE_ICON, CROSS_ICON, DRAG_ICON } from '../../../../../../config/svgicons'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { Modcfm } from '../../../../../../components';
import Explain from "../Explain";

const dragsvgcss = { width: 20, height: 20, display: 'flex', placeContent: 'center', margin: 5 }
const crosssvgcss = { ...dragsvgcss, color: 'var(--mainpink)' }
const addsvgcss = { width: 23, height: 23, display: 'flex', placeContent: 'center', pointerEvent: 'none' }
const blocksvgcss = { ...dragsvgcss, color: 'var(--subdark)' }

const TITLE = 'Registry'
const TEXT = `Guide your guests who are checking your registry to an alternative platform for registries.`

const DEFAULT_PAGE = 0
const SWAP_OR_EDIT_PAGE = 1

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? '#707070' : 'white',
    padding: isDraggingOver ? 5 : 0,
});

function Registry(props) {
    const { device, partialwt, showsave, setShowsave, updateBackup, clearBackup, restoreBackup, updateRegistry, saveRegistry } = props

    const [firsttime, setFirsttime] = useState(true)
    const [page, setPage] = useState(DEFAULT_PAGE) // 0 : default schedule page, 1 : swapping page, 2 : create schedule page, 3 : edit page

    // Registry arr
    const [registrydata, setRegistrydata] = useState([])

    // remove 
    const [rmvindex, setRmvindex] = useState(-1) // index to remove
    const [rmvcfm, setRmvcfm] = useState(false) // user click cfm or not cfm delete
    const [showrmvmod, setShowrmvmod] = useState(false) // toggle rmv modal to title user

    useEffect(() => {
        if (firsttime) {
            setRegistrydata(props.registrydata.slice())
            setFirsttime(false)
            setPage(DEFAULT_PAGE)
        }
    }, [])

    useEffect(() => {
        if (!firsttime) {
            setRegistrydata(props.registrydata.slice())
        }
    }, [props.registrydata])

    useEffect(() => {
        if (rmvcfm) {
            let newqnas = JSON.parse(JSON.stringify(registrydata))
            newqnas.splice(rmvindex, 1)
            newqnas = flattenqn(newqnas)
            saveRegistry(newqnas, 'remove').then((result) => {
                if (result === 'SUCCESS') {
                    setPage(DEFAULT_PAGE)
                    setShowsave(false)
                    setRmvcfm(false)
                }
            })
        }
    }, [rmvcfm])

    const flattenqn = (data) => {
        var new_qnas = []
        for (let i = 0; i < data.length; i++) {
            const { title, url } = data[i]
            new_qnas.push(title)
            new_qnas.push(url)
        }
        return new_qnas
    }

    const onDragend = (result) => {
        const { source, destination } = result
        if (!destination) { return }
        else {
            if (page !== SWAP_OR_EDIT_PAGE && source.index !== destination.index) {
                setPage(SWAP_OR_EDIT_PAGE)
            }
            else if (page === SWAP_OR_EDIT_PAGE && source.index === destination.index) {
                return
            }
            if (!showsave) { updateBackup(); setShowsave(true); }
            let curr_qndata = registrydata.slice()
            const [removed] = curr_qndata.splice(source.index, 1);
            curr_qndata.splice(destination.index, 0, removed);
            updateRegistry(flattenqn(curr_qndata))
            setRegistrydata(curr_qndata)
        }
    }

    const revert = () => {
        setShowsave(false)
        restoreBackup()
        setPage(DEFAULT_PAGE)
    }

    const create = (action) => {
        saveRegistry([...flattenqn(registrydata), "", ""], action).then((result) => {
            if (result === 'SUCCESS') {
                setPage(DEFAULT_PAGE)
                setShowsave(false)
                clearBackup()
            }
        })
    }

    const update = (action) => {
        saveRegistry(flattenqn(registrydata), action).then((result) => {
            if (result === 'SUCCESS') {
                setPage(DEFAULT_PAGE)
                setShowsave(false)
                clearBackup()
            }
        })
    }

    const remove = (i) => { // see useEffect
        setShowrmvmod(() => {
            setRmvindex(i)
            return true
        })
    }

    const btmbarstyle = {
        'MOBILE': { position: 'fixed', bottom: 0, left: 0, width: '100%' },
        'TABLET': { position: 'fixed', bottom: 10, left: 0, width: partialwt - 1 },
        'WEB': { position: 'fixed', bottom: 0, left: 0, width: partialwt - 1 }
    }[device]

    const btmbar = {
        // display question
        0: <div className='iedit_swaproot' style={btmbarstyle}>
            <button className='iedit_add' onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); }; create('add'); }}>{iconwrapper(ADD_ICON, addsvgcss)}</button>
        </div>,
        // swap or edit question
        1: <div className='iedit_swaproot' style={btmbarstyle}>
            <button
                className='iedit_cancel'
                disabled={!showsave}
                style={{ opacity: !showsave ? 0.5 : 1 }}
                onClick={revert}
            >
                Revert
            </button>
            <button className='iedit_save' onClick={() => { update('update') }}>Save</button>
        </div>
    }[page]

    const dnd = <div>
        <DragDropContext onDragEnd={onDragend}>
            <Droppable droppableId={'droppable'} >
                {(provided, snapshot) => (
                    <div className='Detailsdrag_root' ref={provided.innerRef} {...provided.droppableProps} style={getListStyle(snapshot.isDraggingOver)}>
                        {registrydata.map((item, x) => {
                            const { title, url } = item
                            const i = x
                            return <Draggable key={x + '_'} draggableId={x + 'id'} index={i}>
                                {(provided, snapshot) => (
                                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                        <div className="Iedit_twoinputs" key={i + 'qna'} >
                                            {page === DEFAULT_PAGE
                                                ? <span className='Detailsdrag_closeicon' onClick={() => remove(i)}>{iconwrapper(CROSS_ICON, crosssvgcss)}</span>
                                                : <span className='Detailsdrag_closeicon'>{iconwrapper(BLOCKLARGE_ICON, blocksvgcss)}</span>
                                            }
                                            <div className='Detailsdrag_col'>
                                                <input
                                                    className="Iedit_input Iedit_topinput"
                                                    value={title}
                                                    placeholder={'Registry Title'}
                                                    onChange={(e) => {
                                                        e.persist();
                                                        if (!showsave) { updateBackup(); setShowsave(true); setPage(SWAP_OR_EDIT_PAGE) }
                                                        setRegistrydata((registrydata) => {
                                                            var new_qndata = JSON.parse(JSON.stringify(registrydata))
                                                            new_qndata[i] = { 'title': e.target.value, 'url': url }
                                                            updateRegistry(flattenqn(new_qndata))
                                                            return new_qndata
                                                        })
                                                    }}
                                                />
                                                <input
                                                    className="Iedit_input Iedit_btminput"
                                                    value={url}
                                                    placeholder={'Registry URL'}
                                                    onChange={(e) => {
                                                        e.persist();
                                                        if (!showsave) { updateBackup(); setShowsave(true); setPage(SWAP_OR_EDIT_PAGE) }
                                                        setRegistrydata((registrydata) => {
                                                            var new_qndata = JSON.parse(JSON.stringify(registrydata))
                                                            new_qndata[i] = { 'title': title, 'url': e.target.value }
                                                            updateRegistry(flattenqn(new_qndata))
                                                            return new_qndata
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <span className='Detailsdrag_dragicon' {...provided.dragHandleProps}>
                                                {iconwrapper(DRAG_ICON, dragsvgcss)}
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
        {btmbar}
    </div>

    return (
        <div className='Ieditcomp_div'
            style={{
                height: {
                    'WEB': 'calc(100% - 70px - 65px)',
                    'TABLET': 'calc(100% - 70px - 65px)',
                    'MOBILE': 'calc(100% - 70px)'
                }[device],
                marginBottom: {
                    'MOBILE': 65
                }[device]
            }}>
            <Explain title={TITLE} txt={TEXT} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {/* {maincontent[page]} */}
                {dnd}
            </div>
            {showrmvmod
                ? <Modcfm
                    onHide={() => { setShowrmvmod(false) }}
                    onOk={() => { setShowrmvmod(false); setRmvcfm(true); }}
                    onNo={() => { setShowrmvmod(false); setRmvcfm(false); setRmvindex(-1); }}
                    txt={'Once you delete this, there is no going back. Please be certain.'}
                />
                : null}
        </div>
    )
}

export default Registry